<template>
    <div v-if="applicationDog">
        <div
            v-if="applicationDog && applicationDog.dog"
            class="kgr-alert kgr-alert--success"
        >
            <a
                :href="getDogLink(applicationDog)"
                class="kgr-link"
            >
                Zum Hund
            </a>
        </div>

        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-row">
            {{ $t('club.member.application.category.baseData') }}
        </h3>

        <kgr-form-row
            :label="$t('Name')"
            :error="error"
            field-name="name"
            required
        >
            <input
                v-model.trim="applicationDog.name"
                type="text"
                class="kgr-input"
                :disabled="!editable"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Wurfdatum')"
            :error="error"
            field-name="dateOfBirth"
        >
            <kgr-date-picker
                v-model.trim="applicationDog.dateOfBirth"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Chipnummer')"
            :error="error"
            field-name="chipNumber"
        >
            <input
                v-model.trim="applicationDog.chipNumber"
                type="text"
                class="kgr-input"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Rasse')"
            :error="error"
            field-name="breed"
        >
            <kgr-dog-breed-select
                v-model="applicationDog.breed"
                :club-id="clubId"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Rasse Spezialisierung')"
            :error="error"
            field-name="breedSpecialization"
        >
            <kgr-dog-breed-specialization-select
                v-model="applicationDog.breedSpecialization"
                :club-id="clubId"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Zuchtbuchnummer')"
            :error="error"
            field-name="breedingBookNumber"
        >
            <input
                v-model.trim="applicationDog.breedingBookNumber"
                type="text"
                class="kgr-input"
            />
        </kgr-form-row>
        <hr class="kgr-separator kgr-separator--light" />
        <div v-if="handlers.length">
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-row">
                {{ $t('club.dog.memberRelation.association.handler') }}
            </h3>
            <ul>
                <li
                    v-for="handler in handlers"
                    :key="handler.id"
                >
                    {{ handler.name }}
                </li>
            </ul>
        </div>
        <div class="kgr-row">
        </div>
        <div v-if="owners.length">
            <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-row">
                {{ $t('club.dog.memberRelation.association.owner') }}
            </h3>
            <ul>
                <li
                    v-for="owner in owners"
                    :key="owner.id"
                >
                    {{ owner.name }}
                </li>
            </ul>
        </div>

        <hr class="kgr-separator kgr-separator--light" />
        <kgr-button
            v-if="editable"
            v-t="'Speichern'"
            type="blue"
            @click="save()"
        />
    </div>
</template>

<script>
import ApplicationDog from '../../js/dto/ApplicationDog.js';
import ApplicationDogRepository from '../../js/repository/ApplicationDogRepository.js';
import DatePicker from '../../components/common/form/picker/DatePicker.vue';
import DogBreedSelect from '../../components/dog/DogBreedSelect.vue';
import DogBreedSpecializationSelect from '../../components/dog/DogBreedSpecializationSelect.vue';
import Error from '../../js/model/Error.js';
import FormRow from '../../components/common/form/FormRow.vue';
import KgrButton from '../../components/common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-dog-breed-select': DogBreedSelect,
        'kgr-dog-breed-specialization-select': DogBreedSpecializationSelect,
    },
    props: {
        dog: {
            type: ApplicationDog,
            required: true,
        },
        members: {
            type: Array,
            required: false,
            default: () => [],
        },
        clubId: {
            type: Number,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            error: new Error(),
            applicationDog: null,
        };
    },
    computed: {
        owners() {
            return this.members
                .filter((member) => this.applicationDog?.ownerRegistrationMemberIds?.includes(member.id))
                .map((member) => ({
                    id: member.id,
                    name: member.getFullName(),
                }));
        },
        handlers() {
            return this.members
                .filter((member) => this.applicationDog?.handlerRegistrationMemberIds?.includes(member.id))
                .map((member) => ({
                    id: member.id,
                    name: member.getFullName(),
                }));
        },
    },
    mounted() {
        this.applicationDog = this.dog;
    },
    methods: {
        save() {
            this.error = new Error();
            ApplicationDogRepository.update(this.applicationDog)
                .then(() => this.$notify.success('saveChanges.success'))
                .catch((error) => {
                    this.$notify.error('saveChanges.error');
                    this.error = error;
                });
        },
        getDogLink(applicationDog) {
            if (applicationDog.dog === null) {
                return null;
            }
            return `/backend/clubs/dogs/${applicationDog.dog.id}/show`;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
